module.exports = {"missingPermission":"Sorry, you currently don’t have access to this page.","contactAdministration":"Reach out to the person in your company who administers this Trustpilot account."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/en-GB/strings.json
// module id = 1225
// module chunks = 0